import React from 'react';
import axios from "axios";
import { toast } from "react-toastify";

import Icon from '../Components/Common/DesignSystem/Icons/Icon';
import { checkCredentials } from './checkCredentials';
import { Oval } from 'react-loader-spinner';
import colours from '../Components/Common/DesignSystem/Colours';
import { P3, P3Bold } from '../Components/Common/DesignSystem/Text';
import moment from 'moment';

export const exportToastAsync = ({ type, request, onResolve, onReject }) => {
    toast.promise(new Promise((resolve, reject) => {
        axios(request)
            .then(function (response) {
                checkCredentials(response);
                resolve(onResolve(response?.data.data));
            })
            .catch(function (error) {
                reject(onReject(error));
            })
    }), {
        pending: {
            render() {
                return (
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <P3Bold>Preparing Report</P3Bold>
                        <div style={{ display: 'inline-flex', alignItems: 'center', color: colours.primary.grey02 }}><Icon name="File" size={12} style={{ color: colours.primary.grey02 }} /><P3>{type}_Report.csv</P3></div>
                    </div>
                )
            },
            icon: <Oval arialLabel="loading-indicator" height={24} width={24} color={colours.primary.blue} secondaryColor={colours.functional.hover_primaryblue} />,
            closeButton: true
        },
        error: {
            render({ error }) {
                return (
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <P3Bold>Export Failed</P3Bold>
                        <div style={{ display: 'inline-flex', alignItems: 'center', color: colours.primary.grey02 }}><Icon name="File" size={12} style={{ color: colours.primary.grey02 }} /><P3>{type}_Report.csv</P3></div>
                    </div>
                )
            },
            icon: <Icon name="AttentionForm" size={24} style={{ color: colours.accent.error_red }} />,
        },
        success: {
            render({ data }) {
                setTimeout(() => {
                    downloadFile(data, type + '_overview_' + moment().format('MM-DD-YYYY') + '.csv');
                }, 500)
                return (
                    <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <a download={type + "_overview.csv"} style={{ color: colours.primary.grey01 }}><P3Bold>Report Ready</P3Bold></a>
                            <div style={{ display: 'inline-flex', alignItems: 'center', color: colours.primary.grey02 }}><Icon name="File" size={12} style={{ color: colours.primary.grey02 }} /><P3>{type}_Report.csv</P3></div>
                        </div>
                    </div>
                )
            },
            icon: <Icon name="Check" size={24} style={{ borderRadius: '8px', color: colours.accent.validate_green, backgroundColor: colours.functional.hover_secondarygreen }} />,
            pauseOnFocusLoss: false
        }
    })
}

export const exportToast = ({ type, data, action }) => {
    let res = action(data);
    let filename = data?.time_period && data?.sh ?
        type + '_overview_' + data.sh + '_' + data.time_period + '.csv'
        : type + '_overview_' + moment().format('MM-DD-YYYY') + '.csv';

    if (res) {
        setTimeout(() => {
            downloadFile(res, filename);
        }, 500)
        toast(<>
            <div style={{ display: 'flex', flex: 1, flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <a download={type + "_overview.csv"} style={{ color: colours.primary.grey01 }}><P3Bold>Report Ready</P3Bold></a>
                    <div style={{ display: 'inline-flex', alignItems: 'center', color: colours.primary.grey02 }}><Icon name="File" size={12} style={{ color: colours.primary.grey02 }} /><P3>{type}_Report.csv</P3></div>
                </div>
            </div>
        </>, { type: 'success', icon: <Icon name="Check" size={24} style={{ borderRadius: '8px', color: colours.accent.validate_green, backgroundColor: colours.functional.hover_secondarygreen }} />, });
    }
}

function downloadFile(filePath, name) {
    var link = document.createElement('a');
    link.href = filePath;
    link.download = name;
    link.click();
}

export const generateVehicleReport = (veh_arr) => {
    let csvContent = "data:text/csv;charset=utf-8,";
    let cols = [
        'VIN',
        'Year',
        'Make',
        'Model',
        'Trim',
        'Status',
        'Department',
        'Vehicle Center',
        'Utilization % (Last 3 months)',
        'Mileage (KM)',
        'Total Bookings'
    ]

    csvContent += cols.join(',') + "\r\n";

    try {
        veh_arr.forEach(function (veh) {
            let row =
                veh.VIN + ',' +
                veh.Year + ',' +
                veh.Make + ',' +
                veh.Model + ',' +
                veh.Trim + ',' +
                veh.status + ',' +
                veh.stakeholder.Company + ' ' + veh.stakeholder.Division + ',' +
                veh.vmh.Display_Name + ' - ' + veh.vmh.Display_City + ',' +
                (veh.utilization && veh.utilization.utilization ? veh.utilization.utilization : '') + ',' +
                veh.Odometer + ',' +
                (veh.utilization && veh.utilization.total_bookings ? veh.utilization.total_bookings : '0');

            csvContent += row + "\r\n";
        });
        return encodeURI(csvContent);
    } catch (err) {
        // console.log(err);
    }
}

export const generateDashboardReport = ({ dash_data, time_period, sh }) => {
    let csvContent = "data:text/csv;charset=utf-8,";

    csvContent += time_period + ' for ' + sh + ' as of ' + moment().format('MMM DD YYYY') + '' + '\r\n';
    csvContent += 'Bookings' + '\r\n';
    csvContent += 'Approved Bookings'
        + ',' + dash_data.bookingData.bookingsInsights.bookedBookings
        + ',' + 'Annual Avg'
        + ',' + dash_data.bookingData.annualBookingInsights.bookedBookings
        + '\r\n';
    csvContent += 'Avg Booking Duration (days)'
        + ',' + Math.round(dash_data.bookingData.bookingsInsights.averageDuration)
        + ',' + 'Annual Avg'
        + ',' + Math.round(dash_data.bookingData.annualBookingInsights.averageDuration)
        + '\r\n';
    csvContent += 'Avg Bookings Per Location'
        + ',' + Math.round(dash_data.bookingData.bookingsInsights.averageBookingsPerLocation)
        + ',' + 'Annual Avg'
        + ',' + Math.round(dash_data.bookingData.annualBookingInsights.averageBookingsPerLocation)
        + '\r\n';
    csvContent += '\r\n';
    csvContent += 'Monthly Bookings' + '\r\n';
    dash_data.bookingData.monthlyBookings.forEach(function (mon) {
        csvContent += mon.name + ',' + mon.value + '\r\n';
    })
    csvContent += '\r\n';
    csvContent += 'Vehicles' + '\r\n';
    csvContent += 'Total'
        + ',' + dash_data.vehicleData.vehiclesInsights.totalVehicles
        + '\r\n';
    csvContent += 'New Vehicles'
        + ',' + dash_data.vehicleData.vehiclesInsights.newVehicles
        + ',' + 'Annual Avg'
        + ',' + dash_data.vehicleData.annualVehicleInsights.newVehicles
        + '\r\n';
    csvContent += 'Damaged Vehicles'
        + ',' + dash_data.vehicleData.vehiclesInsights.damagedVehicles
        + ',' + 'Annual Avg'
        + ',' + dash_data.vehicleData.annualVehicleInsights.damagedVehicles
        + '\r\n';
    csvContent += 'Highest Mileage (KM)'
        + ',' + dash_data.vehicleData.vehiclesInsights.highestMileage
        + ',' + 'Annual Avg'
        + ',' + dash_data.vehicleData.annualVehicleInsights.highestMileage
        + '\r\n';
    csvContent += 'Avg Utilization (%)'
        + ',' + Math.round(dash_data.vehicleData.vehiclesInsights.averageUtilization * 100)
        + ',' + 'Annual Avg'
        + ',' + Math.round(dash_data.vehicleData.annualVehicleInsights.averageUtilization * 100)
        + '\r\n';

    csvContent += '\r\n';
    csvContent += 'Highest Utilization' + '\r\n';
    dash_data.vehicleData.highestUtilizationVehicles.forEach((veh) => {
        csvContent += veh.vehicle.displayName + ',' + veh.vehicle.vin + ',' + Math.round(veh.utilization * 100) + '%' + '\r\n'
    });

    csvContent += '\r\n';
    csvContent += 'Lowest Utilization' + '\r\n';
    dash_data.vehicleData.lowestUtilizationVehicles.forEach((veh) => {
        csvContent += veh.vehicle.displayName + ',' + veh.vehicle.vin + ',' + Math.round(veh.utilization * 100) + '%' + '\r\n'
    });

    csvContent += '\r\n';
    csvContent += 'Monthly Utilization' + '\r\n';
    dash_data.vehicleData.monthlyVehiclesUtilizations.forEach(function (mon) {
        csvContent += mon.name + ',' + mon.value + '%' + '\r\n';
    })
    return encodeURI(csvContent);
}